var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-3" }, [
    _c("h3", [_vm._v("Detail Surat Konsultasi")]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-3" }, [
        _c("div", { staticClass: "card mb-3" }, [
          _c("div", { staticClass: "card-header text-white bg-primary" }, [
            _vm._v("Data Pasien"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("table", { staticClass: "table table-striped" }, [
              _c("tbody", [
                _c("tr", [
                  _c("td", [_vm._v("No. RM")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.detail_konsul.Medrec))]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("No. Registrasi")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.detail_konsul.Regno))]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Nama Pasien")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.detail_konsul.Firstname))]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Kategori")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.detail_konsul.NmKategori))]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Jenis Kelamin")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.detail_konsul.Sex))]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Umur")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.detail_konsul.umur_pasien))]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "card mb-3" }, [
          _c("div", { staticClass: "card-header text-white bg-primary" }, [
            _vm._v("Detail Surat Konsul"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("table", { staticClass: "table table-striped" }, [
              _c("tbody", [
                _c("tr", [
                  _c("td", { attrs: { width: "20%" } }, [
                    _vm._v("No. Surat Konsul"),
                  ]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v(_vm._s(_vm.detail_konsul.NoSuratKonsul)),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Tanggal Konsul")]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v(_vm._s(_vm.detail_konsul.tanggal_konsul)),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Poli Asal")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.detail_konsul.poli_asal))]),
                  _vm._v(" "),
                  _c("td", [_vm._v("Dokter Pengirim")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.detail_konsul.doc_asal))]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Poli Tujuan")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.detail_konsul.poli_tujuan))]),
                  _vm._v(" "),
                  _c("td", [_vm._v("Dokter Tuju")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.detail_konsul.doc_tujuan))]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Diagnosa")]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v(_vm._s(_vm.detail_konsul.diagnosa)),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Terapi")]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v(_vm._s(_vm.detail_konsul.Terapi)),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Catatan")]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v(_vm._s(_vm.detail_konsul.Catatan)),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }